import React, { useEffect, useRef, useState } from 'react';

import { Game } from '../../game/Game';
import { Loading } from '../loading/Loading';
import { useLoading } from '../loading/useLoading';
import { CANVAS_GAME_LOADED, GAME_APPLICATION_TYPE_STATE, SOUND_ICON_STATE } from '../../stateManagment';
import { getScreenResolution } from '../../core/helpers/getScreenResolution';
import { Control } from '../controlContent/Control';
import { gameService } from '../../services/apiServices/GameService';
import { DocumentVisibilityState } from '../../core/DocumentVisibilityState';
import { iframeService } from '../../services/helperServices/IframeService';
import { PAGE_TAB_IN_ACTIVE_TIME } from '../../core/constats';
import { soundService } from '../../services/helperServices/SoundService';
import { ToastContainer } from 'react-toastify';
import { TranslationContext } from '../../core/translation/TranslationContext';
import { translationService } from '../../core/translation/translationService';

export const GameContent = () => {
  const { loading } = useLoading();
  const [initialState, setInitialState] = useState(false);
  const [translations, setTranslations] = useState({});
  const [style, setStyle] = useState({});
  const ref = useRef({});

  const handleVisibilityChange = () => {
    if (document.visibilityState === DocumentVisibilityState.visible) {
      if (Date.now() - ref.current.time >= PAGE_TAB_IN_ACTIVE_TIME) {
        if (iframeService.isInIframe()) {
          iframeService.reloadFrame();
        } else {
          window.location.reload();
        }
      }
      if (SOUND_ICON_STATE.getValue()) {
        soundService.unmute();
      }
    } else {
      ref.current.time = Date.now();
      if (SOUND_ICON_STATE.getValue()) {
        soundService.mute();
      }
    }
  };

  useEffect(() => {
    Promise.all([
      translationService.getTranslation(),
      soundService.init(!SOUND_ICON_STATE.getValue()),
      gameService.getInitialState(),
    ]).then(([translation]) => {
      setTranslations(translation);
      setTimeout(() => {
        setInitialState(true);
      }, 1000)
    });

    if (!gameService.isMobile) {
      setStyle(getScreenResolution(GAME_APPLICATION_TYPE_STATE.getValue()));
    }

    window.addEventListener('resize', () => {
      if (!gameService.isMobile) {
        setStyle(getScreenResolution(GAME_APPLICATION_TYPE_STATE.getValue()));
      }
    });

    document.addEventListener('visibilitychange', handleVisibilityChange);
    CANVAS_GAME_LOADED.next(true);

    return () => {
      CANVAS_GAME_LOADED.next(false);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <TranslationContext.Provider value={translations}>
    <section className={`game__container`} style={style}>
      {loading && (<Loading/>)}
      <section className="game__content" style={{
        display: loading ? 'none' : 'block',
        ...style,
      }}>
        {
          initialState && (
            <Control>
              <Game/>
            </Control>
          )
        }
      </section>
    </section>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
      />
    </TranslationContext.Provider>
  );
};
